import apiHandler from "../core/apiHandler";

const salesButtonActionApi = apiHandler('sales/history-actions');
export default salesButtonActionApi;
